/**
 * @generated SignedSource<<5a6ef838815a360b86d1d27c6c294cd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelStage = "CancelImpossible" | "CancelPossibleAfterDeclare" | "CancelPossibleBeforeDeclare" | "CancelPossibleImmediately" | "Canceling";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type homeContentQuery$variables = Record<PropertyKey, never>;
export type homeContentQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly cenSnmcTxreAmt: number | null | undefined;
        readonly empIncrEtrpTxamtDdcAmt: number | null | undefined;
        readonly intgEmpTxamtDdcAmt: number | null | undefined;
        readonly reSearchRequestId: number | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly sctyInfeeTxamtDdcAmt: number | null | undefined;
        readonly snmcSpcTxreAmt: number | null | undefined;
      }> | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly id: string;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly tritxReSearchRequestId: number | null | undefined;
      }> | null | undefined;
    };
  };
  readonly getRefundUserMarketingTerm: {
    readonly terms: ReadonlyArray<{
      readonly isApproved: boolean;
      readonly termKey: string;
    }> | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CorpsSection" | "IndisSection" | "RetryBanner">;
};
export type homeContentQuery = {
  response: homeContentQuery$data;
  variables: homeContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "UserMarketingOutput",
  "kind": "LinkedField",
  "name": "getRefundUserMarketingTerm",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TermsOutput",
      "kind": "LinkedField",
      "name": "terms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "termKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isApproved",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStatus",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "snmcSpcTxreAmt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cenSnmcTxreAmt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "empIncrEtrpTxamtDdcAmt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intgEmpTxamtDdcAmt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sctyInfeeTxamtDdcAmt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reSearchRequestId",
  "storageKey": null
},
v8 = [
  (v1/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tritxReSearchRequestId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxpayerName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStage",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelStage",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundSubStage",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundReportDt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundResultDt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundResultExpectDt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentClosingDt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentAmount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "applicationDt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userFee",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lostReason",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tin",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "office",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "VirtualAccountType",
  "kind": "LinkedField",
  "name": "virtualAccountInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bank",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "account",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "homeContentQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v1/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RetryBanner"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndisSection"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CorpsSection"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "homeContentQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": "refundHistoryId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  (v11/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentExpectDt",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v15/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  (v11/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v15/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RefundPartnerType",
                    "kind": "LinkedField",
                    "name": "partnerInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partnerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feeRate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defaultFeeRate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BusinessInfo",
                    "kind": "LinkedField",
                    "name": "businessInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hometaxBizName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hometaxBizNo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v1/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImputedYearOutput",
            "kind": "LinkedField",
            "name": "imputedYear",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indis",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "corps",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7bb5860d618712a50890e6286d6680f2",
    "id": null,
    "metadata": {},
    "name": "homeContentQuery",
    "operationKind": "query",
    "text": "query homeContentQuery {\n  getRefundUserMarketingTerm {\n    terms {\n      termKey\n      isApproved\n    }\n  }\n  bznavRefund {\n    user {\n      indis {\n        refundStatus\n        snmcSpcTxreAmt\n        cenSnmcTxreAmt\n        empIncrEtrpTxamtDdcAmt\n        intgEmpTxamtDdcAmt\n        sctyInfeeTxamtDdcAmt\n        reSearchRequestId\n        id\n      }\n      corps {\n        refundStatus\n        id\n      }\n      previousIndis {\n        refundStatus\n        id\n      }\n      tritxIndis {\n        id\n        refundId\n        refundAmount\n        refundStatus\n        tritxReSearchRequestId\n        businessInfo {\n          taxpayerName\n        }\n        refundStage\n        cancelStage\n      }\n    }\n  }\n  ...RetryBanner\n  ...IndisSection\n  ...CorpsSection\n}\n\nfragment CorpsSection on Query {\n  bznavRefund {\n    user {\n      corps {\n        refundId\n        refundStatus\n        refundStage\n        refundSubStage\n        refundAmount\n        refundReportDt\n        refundResultDt\n        refundResultExpectDt\n        paymentClosingDt\n        paymentAmount\n        applicationDt\n        cancelStage\n        userFee\n        lostReason\n        tin\n        office\n        virtualAccountInfo {\n          owner\n          bank\n          account\n          paymentAmount\n        }\n        partnerInfo {\n          partnerName\n          feeRate\n          defaultFeeRate\n        }\n        businessInfo {\n          hometaxBizName\n          hometaxBizNo\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment IndisSection on Query {\n  bznavRefund {\n    user {\n      indis {\n        refundHistoryId: id\n        refundId\n        refundStatus\n        refundStage\n        refundSubStage\n        refundAmount\n        refundReportDt\n        refundResultDt\n        refundResultExpectDt\n        paymentClosingDt\n        paymentExpectDt\n        paymentAmount\n        applicationDt\n        cancelStage\n        userFee\n        lostReason\n        tin\n        office\n        snmcSpcTxreAmt\n        cenSnmcTxreAmt\n        empIncrEtrpTxamtDdcAmt\n        intgEmpTxamtDdcAmt\n        sctyInfeeTxamtDdcAmt\n        reSearchRequestId\n        virtualAccountInfo {\n          owner\n          bank\n          account\n          paymentAmount\n        }\n        businessInfo {\n          taxpayerName\n        }\n        id\n      }\n      previousIndis {\n        __typename\n        id\n      }\n      tritxIndis {\n        refundId\n        refundAmount\n        applicationDt\n        refundStatus\n        refundStage\n        tritxReSearchRequestId\n        businessInfo {\n          taxpayerName\n        }\n        cancelStage\n        id\n      }\n    }\n  }\n}\n\nfragment RetryBanner on Query {\n  bznavRefund {\n    user {\n      indis {\n        refundStatus\n        id\n      }\n      corps {\n        refundStatus\n        id\n      }\n      tritxIndis {\n        refundStatus\n        id\n      }\n    }\n    imputedYear {\n      indis\n      corps\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b0831f48b47eecc1449daa9775cccbd";

export default node;
